import { v4 as uuidv4 } from 'uuid';
import {
  CommunicationEvent,
  CommunicationEventType,
  recordCommunicationEvents,
} from '@amzn/brand-registry-communication-service-type-script-client';
import { customerIdFromContext } from 'src/util/metrics';

export const recordEvents = (
  communicationIds: string[],
  eventType: CommunicationEventType
) => {
  const events: CommunicationEvent[] = communicationIds.map((id) => ({
    channel: 'WEBSITE',
    communicationId: id,
    eventId: uuidv4(),
    eventType,
  }));

  // Publishing all events is reserved for on page unload and there is no need to force that here
  const shouldPublishAllEvents = false;

  recordCommunicationEvents(events, shouldPublishAllEvents, 'BrandRegistryTrim', customerIdFromContext);
};
